import React from 'react';

const Polymer = () => {
	return (
		<div className="tpi-coming-soon font-poppins">
			<h1>Coming Soon</h1>
		</div>
	);
};

export default Polymer;
